// src/app/components/auth/signup/signup.component.ts

import { Component } from '@angular/core';
import { Router }    from '@angular/router';
import { AuthService } from '../../../services/auth/auth.service';
import { ThemeService } from '../../../services/theme/theme.service';
import { LanguageService } from '../../../services/language/language.service';
import { FrontendLoggerService } from '../../../services/frontend-logger.service';

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.scss'],
    standalone: false
})
export class SignupComponent {
  isLoading    = false;
  errorMessage = '';

  constructor(
    private authService:   AuthService,
    private router:        Router,
    public themeService:   ThemeService,
    public languageService: LanguageService,
    private readonly frontendLogger: FrontendLoggerService
  ) {}

  signup(): void {
    this.isLoading    = true;
    this.errorMessage = '';

    // lanzamos signup con target '/wizard'
    this.authService.signup('/wizard').subscribe({
      next: () => this.isLoading = false,
      error: err => {
        this.frontendLogger.error('Error durante el registro', err);
        this.errorMessage = 'Error al registrarse. Por favor, inténtalo de nuevo.';
        this.isLoading = false;
      }
    });
  }

  login(): void {
    this.router.navigate(['/login']);
  }

  translate(key: string): string {
    return this.languageService.translate(key);
  }
}
